const Getters = {
  getTransferAccountListFromState: (state) => {
    return state.transferAccountList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
